export default {
  gender: null,
  social_name: null,
  breed: null,
  pronoun: null,
  is_egression: false,
  pcd_reability: false,
  deficiencies: [],
}